export default __webpack_public_path__ + "static/media/overjet.ef0b3bf8.png";